/**
 * Monta o parâmetro `actor` do GetAppointment (IDs de Location separados por vírgula),
 * com a mesma regra de `ProfessionalSchedule` (`contextLocationId`).
 */
export function buildLocationActorFromContext(
  locations: fhir5.BundleEntry<fhir5.Location>[] | undefined,
): string | undefined {
  const ids = (locations ?? [])
    .map((entry) => entry.resource?.id?.trim())
    .filter((id): id is string => Boolean(id));

  if (ids.length === 0) return undefined;
  return ids.join(",");
}
